// TODO: Change 'light' with 'legacy' in the future
const baseThemes = ['light', 'personal'];
const extraThemes = ['forest-green', 'bright-green'];
const screenModes = ['light', 'dark'];
const modernThemes = [baseThemes[1], ...extraThemes];
const DEFAULT_BASE_THEME = 'light';
const DEFAULT_SCREEN_MODE = 'light';

export { DEFAULT_BASE_THEME, DEFAULT_SCREEN_MODE, baseThemes, extraThemes, modernThemes, screenModes };
//# sourceMappingURL=const.mjs.map
